const USERS = 'USERS';
const ARCHIVE = 'ARCHIVE';
const USER_SETTINGS = 'USER_SETTINGS';
const PROJECT_ADD = 'PROJECT_ADD';
const PROJECT_SETTINGS = 'PROJECT_SETTINGS';
const POINT_SYSTEM = 'POINT_SYSTEM';
const MONTHLY_REPORT = 'MONTHLY_REPORT';
const UNCLOSED_TASKS = 'UNCLOSED_TASKS';

export default {
  USERS,
  ARCHIVE,
  USER_SETTINGS,
  PROJECT_ADD,
  PROJECT_SETTINGS,
  POINT_SYSTEM,
  MONTHLY_REPORT,
  UNCLOSED_TASKS,
};
